import client from '../client';

export const analyzeScalpCondition = async (answers) => {
  const res = await client.post('/scalp-data/niita-analyze', { answers });
  const body = res.data;

  return {
    success: body?.success ?? true,
    data: body?.result ?? null,
  };
};
